import Swagger from 'swagger-client';
import spec from '../data/assessment_ui_api';

export const config = {
  // host: process.env.API_HOST || spec.host || 'fuse.nextpathway.com',
  host: process.env.API_HOST || spec.host || 'fuse.nextpathway.com',
  STMhost: process.env.API_HOST || spec.stm || 'https://fuse.nextpathway.com',
  // host: process.env.API_HOST || spec.host || 'fuse.nextpathway.com',
  basePath: process.env.API_BASE_PATH || spec.basePath || '/api',
  protocol : 'https',
  unregister_url : 'https://aws.amazon.com/marketplace/pp/B089DNN54Z'
};

const swaggerClient = () =>
  Swagger({
    spec,
    requestInterceptor: request => {
      console.log(request);
      request.headers['Content-Type'] = 'application/json;charset=UTF-8';
      if (sessionStorage.getItem('jwt') != null) {
        request.headers['Authorization'] = sessionStorage.getItem('jwt');
      }
      request.url = `${config.protocol}://${config.host}${config.basePath}${request.url}`;

      return request;
    }
  });

export default swaggerClient;



// WEBPACK FOOTER //
// ./src/utility/swaggerClient.js